import { render, staticRenderFns } from "./CameraAccess.vue?vue&type=template&id=b139e87a&scoped=true"
import script from "./CameraAccess.vue?vue&type=script&lang=js"
export * from "./CameraAccess.vue?vue&type=script&lang=js"
import style0 from "./CameraAccess.vue?vue&type=style&index=0&id=b139e87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b139e87a",
  null
  
)

export default component.exports